const baseUsertUrl = "User"


  const endpoints = {
   getLastViewedList:`${baseUsertUrl}/GetUserLastViewed`,
   
   
   
  };
  
  export default endpoints;
  